import { encrypt, decrypt } from 'crypto-js/aes'
import { mode, pad, enc } from 'crypto-js'
import { parse as base64parse } from 'crypto-js/enc-base64'

/**
 브라우저 호환 암호화 utility
 @packageDocumentation
 */

/**
 * AES256 Encyript
 * @param data
 * @param secret
 */
export const encryptAes256 = (data: string, secret: string) => {
  return encrypt(data, base64parse(secret), {
    mode: mode.ECB,
    padding: pad.Pkcs7,
  }).toString()
}

/**
 * AES256 Decrypt
 * @param data
 * @param secret
 */
export const decryptAes256 = (data: string, secret: string) => {
  return decrypt(data, base64parse(secret), {
    mode: mode.ECB,
    padding: pad.Pkcs7,
  }).toString(enc.Utf8)
}
